export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const API_WS_ROOT = process.env.REACT_APP_API_WS_ROOT;

console.log(API_WS_ROOT);

export const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};